import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { ThumbSwiperProps } from '../types';
import ImageComponent from './ImageComponent';
import VideoCover from './VideoCover';

export const ThumbSwiper = ({
  paramsSmallSwiper,
  setThumbsSwiper,
  images,
  title,
  video,
}: ThumbSwiperProps) => (
  <StyledSmallSwiper
    {...paramsSmallSwiper}
    onSwiper={setThumbsSwiper}
    slidesPerView={24}
    watchSlidesProgress
    className="swiper-container"
  >
    <div className="swiper-wrapper">
      {images.map((image, index) => (
        <SwiperSlide key={`slide-${image.id}`}>
          {!!video && index === 0 ? (
            <VideoCover title={title} coverImage={video.cover} isSmall />
          ) : (
            <ImageComponent src={image.thumbImage ?? ''} title={title} />
          )}
        </SwiperSlide>
      ))}
    </div>
  </StyledSmallSwiper>
);

const StyledSmallSwiper = styled(Swiper)`
  height: 40px;
  cursor: pointer;
  .swiper-slide {
    width: 60px;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  .swiper-slide-visible {
    opacity: 0.5;
  }
  // Из-за slidesPerView = auto библиотека не может определить активные слайды, поэтому приходится так стилизовать
  .swiper-slide-thumb-active {
    opacity: 1;
  }
  .swiper-slide-thumb-active + .swiper-slide-visible {
    opacity: 1;
  }
  .swiper-slide-thumb-active + .swiper-slide-visible + .swiper-slide-visible {
    opacity: 1;
  }
  .swiper-wrapper {
    width: fit-content;
  }
`;
